import React, { useEffect, useState, useRef } from "react";
import "./DerbyRace.css";


export default function DerbyRace({
  horses = [],
  round = 3,
  spades_desc = [],
  hearts_desc = [],
  clubs_desc = [],
  diamonds_desc = [],
  current_desc = [],
}) {
  const FINISH_POSITION = 84;
  const RUN_AREA = 50;
  const WINNER_RUN_TIME = 2000;
  //console.log("current_desc->", current_desc);

  const lastRawPositionsRef = useRef({});
  const winnerFreezeRef = useRef(false);

  const [positions, setPositions] = useState({});
  const [showFinish, setShowFinish] = useState(false);
  const [winnerFinished, setWinnerFinished] = useState(false);

  const winner = horses.find((h) => h.isWinner);
  const winnerId = winner ? winner.id : null;

  const getHorseImage = (horse) => {
    if (round <= 2 || winnerFinished) {
      return horse.stillImage;
    } else {
      return horse.runImage;
    }
  };

  useEffect(() => {
    if (!horses.length) return;

    const newPositions = {};
    const protectedRawMap = {};

    if (round <= 2) {
      lastRawPositionsRef.current = {};
      winnerFreezeRef.current = false;

      const resetPositions = {};
      horses.forEach((horse) => {
        resetPositions[horse.id] = 0;
      });

      setPositions(resetPositions);
      setShowFinish(false);

      setWinnerFinished(false);
      return;
    }

    // Freeze everything before race
    if (round <= 2) {
      horses.forEach((horse) => {
        newPositions[horse.id] = 0;
      });

      winnerFreezeRef.current = false;
      setPositions(newPositions);
      setShowFinish(false);
      return;
    }

    // Protect raw values from going backwards
    horses.forEach((horse) => {
      let raw = horse.position ?? 0;
      const lastRaw = lastRawPositionsRef.current[horse.id] ?? raw;

      //if (!winnerFreezeRef.current && raw < lastRaw) {
      if (!winnerFreezeRef.current && raw == 0) {
        raw = lastRaw;
      }

      lastRawPositionsRef.current[horse.id] = raw;
      protectedRawMap[horse.id] = raw;
    });

    // Leader-based scaling
    let raceMax = 1;
    Object.values(protectedRawMap).forEach((raw) => {
      raceMax = Math.max(raceMax, raw);
      raceMax = raceMax * 1.15;
    });
    let ifAllHorsesAtZero = 0;
    horses.forEach((horse) => {
      const raw = protectedRawMap[horse.id];

      let pos;

      if (horse.isWinner) {
        pos = FINISH_POSITION;

        setShowFinish(true);
      } else if (winnerFreezeRef.current) {
        pos = positions[horse.id] ?? 0;
      } else {
        pos = Math.max(RUN_AREA - (raw / raceMax) * RUN_AREA, 0);

        //pos = raw;
      }
      ifAllHorsesAtZero += pos;
      newPositions[horse.id] = pos;
    });
    //console.log("ifAllHorsesAtZero: ",ifAllHorsesAtZero);

    console.log(
      newPositions[0] +
        "==" +
        newPositions[1] +
        "==" +
        newPositions[2] +
        "==" +
        newPositions[3]
    );
    if (
      Number(newPositions[0]) === Number(newPositions[1]) &&
      Number(newPositions[1]) === Number(newPositions[2]) &&
      Number(newPositions[2]) === Number(newPositions[3])
    ) {
      console.log("new pos: ", newPositions[0]);
      console.log("Racemax: ", raceMax);
      //if(ifAllHorsesAtZero === 0) {

      const resetPositions = {};
      horses.forEach((horse) => {
        resetPositions[horse.id] = 0;
      });

      setPositions(resetPositions);
    } else {
      console.log("+++++++++++++++");
      setPositions(newPositions);
    }

    if (winnerId) {
      setShowFinish(true);

      if (winnerId && !winnerFreezeRef.current) {
        winnerFreezeRef.current = true;

        setShowFinish(true);

        setTimeout(() => {
          setWinnerFinished(true);
        }, WINNER_RUN_TIME);
      }
    }
  }, [horses, round, winnerId]);

  const pauseBg = round <= 2 || winnerFreezeRef.current;
  return (
    <div
      id="raceTrack"
      className={`Derb-track-container ${pauseBg ? "paused" : ""}`}
    >
      <div className="Derb-HC-accordion-body is-active">
        <div>
          <div>
            <h6 style={{ color: "white", fontSize: "15px", fontWeight: "600" }}>
              Handicap Cards
            </h6>
          </div>
          <div className="Derb-HC-handicap-cards">
            <div className="Derb-HC-icon-card">
              <img
                src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_spades.svg?v=1233"
                alt="icon"
              />
            </div>
            <div className="Derb-HC-cards-content">
              {spades_desc &&
                spades_desc.length > 0 &&
                spades_desc.map((card, index) => {
                  const cardClass = `sprite-card-chs-card svg-card_simple_1-dims trans_6 svg-card_simple_${card}`;
                  return <div className={cardClass} />;
                })}
            </div>
          </div>
          <div className="Derb-HC-handicap-cards">
            <div className="Derb-HC-icon-card">
              <img
                src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_hearts.svg?v=1233"
                alt="icon"
              />
            </div>
            <div className="Derb-HC-cards-content">
              {hearts_desc &&
                hearts_desc.length > 0 &&
                hearts_desc.map((card, index) => {
                  const cardClass = `sprite-card-chs-card svg-card_simple_1-dims trans_6 svg-card_simple_${card}`;
                  return <div className={cardClass} />;
                })}
            </div>
          </div>
          <div className="Derb-HC-handicap-cards">
            <div className="Derb-HC-icon-card">
              <img
                src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_clubs.svg?v=1233"
                alt="icon"
              />
            </div>
            <div className="Derb-HC-cards-content">
              {clubs_desc &&
                clubs_desc.length > 0 &&
                clubs_desc.map((card, index) => {
                  const cardClass = `sprite-card-chs-card svg-card_simple_1-dims trans_6 svg-card_simple_${card}`;
                  return <div className={cardClass} />;
                })}
            </div>
          </div>
          <div className="Derb-HC-handicap-cards">
            <div className="Derb-HC-icon-card">
              <img
                src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_diamonds.svg?v=1233"
                alt="icon"
              />
            </div>
            <div className="Derb-HC-cards-content">
              {diamonds_desc &&
                diamonds_desc.length > 0 &&
                diamonds_desc.map((card, index) => {
                  const cardClass = `sprite-card-chs-card svg-card_simple_1-dims trans_6 svg-card_simple_${card}`;
                  return <div className={cardClass} />;
                })}
            </div>
          </div>
        </div>
      </div>

      <div class="Derb-HC-cards-drawn-container" style={{ zIndex: 10 }}>
        {current_desc &&
          current_desc.length > 0 &&
          current_desc.map((card, index) => {
            const cardClass = `sprite-card-chs-card svg-card_simple_1-dims svg-card_simple_${card}`;
            return <div className={cardClass} />;
          })}
      </div>

      <div className="Derb-sky">
        <img src="/assets/images/bpstudio/derby/sky.png" alt="" />
      </div>

      <div className={`Derb-flags ${pauseBg ? "" : "flag-animate"}`}>
        <div className="flag-scroll" />
      </div>

      <div className={`Derb-fence ${pauseBg ? "" : "fence-animate"}`}>
        <div className="fence-scroll" />
      </div>

      <div className="Derb-background">
        <img src="/assets/images/bpstudio/derby/background.png" alt="" />
      </div>

      {round <= 2 && (
        <div className="Derb-startline">
          <img src="/assets/images/bpstudio/derby/Line.png" alt="" />
        </div>
      )}

      {horses.map((horse, index) => (
        <div key={horse.id} className={`Derb-lane Derb-lane${index}`}>
          <div className="Derb-line" />
          {/*}
          <div
            style={{
              left: `${horse.isWinner ? 80 : positions[horse.id] ?? 0}%`,
              position: "absolute",
              zIndex: "999",
              transition: horse.isWinner
                ? "left 2s ease-out"
                : winnerFreezeRef.current
                ? "none"
                : "left 0.4s linear",
            }}
          >
            {positions[horse.id]}
          </div>*/}
          <img
            src={getHorseImage(horse)}
            className={`Derb-horse${index}`}
            style={{
              left: `${horse.isWinner ? 80 : positions[horse.id] ?? 0}%`,
              position: "absolute",
              transition: horse.isWinner
                ? "left 2s ease-out"
                : winnerFreezeRef.current
                ? "none"
                : "left 0.4s linear"
            }}
            alt=""
            draggable={false}
          />
        </div>
      ))}

      {showFinish && (
        <div className="Derb-finishline reveal">
          <img
            src="/assets/images/bpstudio/derby/finishline.svg"
            alt=""
            draggable={false}
          />
        </div>
      )}
    </div>
  );
}
